const requireContext = require.context('.', false, /\.js$/)

let routes = []

requireContext.keys().forEach(item => {
    if (item === './index.js') return
    const module = requireContext(item).default
    routes = routes.concat(module)
})

export default routes
